import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetPassengerByIdCommand extends IRequestCommand<
  IGetPassengerByIdResponse,
  ErrorDetails,
  IGetPassengerByIdParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'passengers/{passengerUserId}?carrierId={carrierId}'

  public override setParameters(parameters: IGetPassengerByIdParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{passengerUserId}',
      parameters.idPassenger ? parameters.idPassenger.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.idCarrier ? parameters.idCarrier.toString() : ''
    );
    this._commandBody = parameters;
  }
}

export interface IGetPassengerByIdParameters {
  idPassenger: number;
  idCarrier?: number;
}

export interface IGetPassengerByIdResponse extends ICommandResponse {
}
